"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var server_1 = require("react-dom/server");
var MediaLibrary_module_css_1 = __importDefault(require("./MediaLibrary.module.css"));
var react_filepond_1 = require("react-filepond");
require("filepond/dist/filepond.min.css");
var filepond_plugin_file_validate_type_1 = __importDefault(require("filepond-plugin-file-validate-type"));
(0, react_filepond_1.registerPlugin)(filepond_plugin_file_validate_type_1.default);
var UploadMedia = function (_a) {
    var updateFiles = _a.updateFiles, t = _a.t, disabled = _a.disabled, collectionName = _a.collectionName, editorType = _a.editorType, version = _a.version, id = _a.id, style = _a.style;
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)([]), files = _b[0], setFiles = _b[1];
    var _c = (0, react_1.useState)({}), completionTimes = _c[0], setCompletionTimes = _c[1];
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            var now = Date.now();
            setFiles(function (currentFiles) {
                return currentFiles.filter(function (file) {
                    var completionTime = completionTimes[file.id];
                    if (completionTime && now - completionTime >= 10000) {
                        delete completionTimes[file.id];
                        return false;
                    }
                    return true;
                });
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [completionTimes]);
    var genLabel = function () {
        return (0, server_1.renderToString)(react_1.default.createElement("span", { className: "".concat(MediaLibrary_module_css_1.default["idle-label-primary-text"], " ns-font-family-bold") },
            t("Drag & Drop your files here or"),
            " ",
            react_1.default.createElement("span", { className: "".concat(MediaLibrary_module_css_1.default["idle-label-secondary-text"], " ns-font-family-bold") }, t("browse"))));
    };
    var endpoint;
    if (editorType === "app") {
        endpoint = "/api/developer-media/".concat(id, "/").concat(version);
    }
    else if (editorType === "template") {
        endpoint = "/api/developer-media/template/".concat(id, "/").concat(version);
    }
    else {
        endpoint = "/api/medialibrary/".concat(collectionName);
    }
    var serverConfig = {
        process: function (fieldName, file, metadata, load, error, progress, abort) {
            var progressEventHandler = function (event) {
                progress(event.lengthComputable, event.loaded, event.total);
            };
            // fieldName is the name of the input field
            // file is the actual file object to send
            var formData = new FormData();
            formData.append(fieldName, file, file.name);
            var uploadFile = onlineResourceManager.makeRequest(endpoint, "POST", formData, {
                onUploadProgress: progressEventHandler,
            });
            uploadFile
                .getResponseRaw()
                .then(function (res) {
                if (res.status >= 200 && res.status < 300) {
                    load(res.data.media);
                    updateFiles === null || updateFiles === void 0 ? void 0 : updateFiles();
                    setCompletionTimes(function (prevTimes) {
                        var _a;
                        return (__assign(__assign({}, prevTimes), (_a = {}, _a[file.id] = Date.now(), _a)));
                    });
                }
                else {
                    var errorObj = new Error("Error uploading file with status code: " + res.status);
                    logger.error(errorObj.message, errorObj);
                    error("Error uploading file");
                }
            })
                .catch(function (err) {
                logger.error("Error uploading file:", err);
                error("Error uploading file");
            });
            // Should expose an abort method so the request can be cancelled
            return {
                abort: function () {
                    uploadFile.abort();
                    // Let FilePond know the request has been cancelled
                    updateFiles === null || updateFiles === void 0 ? void 0 : updateFiles();
                    abort();
                },
            };
        },
        revert: null,
        restore: null,
        fetch: null,
    };
    var defaultStyle = {
        width: "50%",
        maxHeight: "300px",
        overflow: "auto",
    };
    return (react_1.default.createElement("div", { style: __assign(__assign({}, defaultStyle), style) },
        react_1.default.createElement(react_filepond_1.FilePond, { className: MediaLibrary_module_css_1.default["ns-filepond-root"], files: files, onupdatefiles: setFiles, allowMultiple: true, server: serverConfig, name: "mediaFile", credits: false, dropOnPage: true, labelIdle: genLabel(), labelTapToUndo: "", 
            // Translations for different states doing file handling
            labelFileWaitingForSize: t("Waiting for size"), labelFileSizeNotAvailable: t("Size not available"), labelFileLoading: t("Loading"), labelFileLoadError: t("Error during load"), labelFileProcessing: t("Uploading"), labelFileProcessingComplete: t("Upload complete"), labelFileProcessingAborted: t("Upload cancelled"), labelFileProcessingError: t("Error during upload"), labelTapToCancel: t("Tap to cancel"), labelTapToRetry: t("Tap to retry"), disabled: disabled, onprocessfile: function (error, file) {
                if (!error) {
                    setCompletionTimes(function (prevTimes) {
                        var _a;
                        return (__assign(__assign({}, prevTimes), (_a = {}, _a[file.id] = Date.now(), _a)));
                    });
                }
            }, acceptedFileTypes: editorType === "app" || editorType === "template" ? ["image/*"] : undefined, fileValidateTypeDetectType: function (source, type) {
                return new Promise(function (resolve) {
                    if ((editorType === "app" || editorType === "template") && !type.startsWith("image/")) {
                        return resolve(null);
                    }
                    resolve(type);
                });
            } })));
};
exports.default = UploadMedia;
